import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="container p-6 launchpad-page">
        <div className="launchpad-title">
          <h1 className="pb-6">Airdrop</h1>
        </div>
        <div className="ant-card ant-card-bordered" style={{ borderRadius: "16px" }}>
          <div className="ant-card-body">
            <nav className="level">
              <div className="level-item has-text-centered">
                <div>
                  <p className="heading">Airdrop Launched</p>
                  <p className="title">245</p>
                </div>
              </div>
              <div className="level-item has-text-centered">
                <div>
                  <p className="heading">Participants in All-time</p>
                  <p className="title">14875</p>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div style={{ height: "24px" }}></div>
        <div className="ant-tabs ant-tabs-top ant-tabs-large ant-tabs-centered">
          <div role="tablist" className="ant-tabs-nav">
            <div className="ant-tabs-nav-wrap">
              <div className="ant-tabs-nav-list" style={{ transform: "translate(0px, 0px)" }}>
                <div className="ant-tabs-tab ant-tabs-tab-active">
                  <div role="tab" aria-selected="true" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-all" aria-controls="rc-tabs-0-panel-all">All Airdrops
                  </div>
                </div>
                <div className="ant-tabs-tab">
                  <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-my" aria-controls="rc-tabs-0-panel-my">My Airdrops
                  </div>
                </div>
                <div className="ant-tabs-tab">
                  <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-own" aria-controls="rc-tabs-0-panel-own">Created By You </div>
                </div>
                <div className="ant-tabs-ink-bar ant-tabs-ink-bar-animated" style={{ left: "0px", width: "83px" }}></div>
              </div>
            </div>
            <div className="ant-tabs-nav-operations ant-tabs-nav-operations-hidden"><button type="button" className="ant-tabs-nav-more" tabindex="-1" aria-hidden="true" aria-haspopup="listbox" aria-controls="rc-tabs-0-more-popup" id="rc-tabs-0-more" aria-expanded="false" style={{ visibility: "hidden", order: "1" }}><span role="img"
              aria-label="ellipsis" className="anticon anticon-ellipsis"><svg
                viewBox="64 64 896 896" focusable="false" data-icon="ellipsis"
                width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path
                  d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z">
                </path>
              </svg></span></button></div>
          </div>
          <div className="ant-tabs-content-holder">
            <div className="ant-tabs-content ant-tabs-content-top">
              <div role="tabpanel" tabindex="0" aria-hidden="false" className="ant-tabs-tabpane ant-tabs-tabpane-active" id="rc-tabs-0-panel-all" aria-labelledby="rc-tabs-0-tab-all">
                <div className="ant-spin-nested-loading">
                  <div className="ant-spin-container">
                    <div className="columns is-multiline">
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668476672313-a1a80f0ba859656a5e0bfe5a387656f8.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">DexCoyote is already trading!</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">HOWL
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xcD1E25B59990Ff55EA2eD928267881dF2FB16E28?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1666736978506-50fa734eba4f5654011dbddc725c4680.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">MetaGamesCoin Airdrop </p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">MGC
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xA3E88C5c6C2E3e1FeE37D56dA4bc040875C6Ff93?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1667651908281-5d1b471c37942a12222cb9703d84ebf4.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot canceled"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Cancelled</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">TSE COINS</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">TSE
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                  <div>Canceled</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x4dE4fCd2d19B261A54c1311BD1265d0799dd5a26?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1667494758003-30d207b66432da8dbae120990eff1bdb.jpeg" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">Join BNB Green AIRDROP</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">bnbg
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x51483E5fE463bD22ab1C20a774e7298bfF5AC792?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://www.hyperonchain.com/img/logo.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">HyperonChain ($HPN) - MainNet Launch Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">HPN
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x33AA8b4FF065a127A219A5Bd26Db47Eeb055276B?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1667077842434-96e9a436e6e74e9e26bb95cf55e286c9.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot canceled"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Cancelled</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">Launch</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">BFK
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                  <div>Canceled</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xc5d064f72ccB316129f77f12995A2dFa666f3f4B?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1666650834944-b5d8112fdf7de92ac8731ed5962c6909.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot canceled"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Cancelled</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">We are Community Token Airdrop </p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">WACT
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                  <div>Canceled</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x7327479DBba188027225d8F055460BaA03110ecB?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1666250589150-276fb4d4f62a2327124b0e6c4b327d0f.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">ZONOV3 Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">ZONOV3
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x2BcB32Ac386E6b6fdd36147cA4A5C7492f0683d3?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="/static/media/pinkswap.a95de4f3.png" alt="" loading="lazy" style={{ filter: "grayscale(1)" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot inprogress"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Live</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">S1 Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">S1</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">10</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">1</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xfDccaDB1FD7e156EA66842e54D0f0f3fc9c62059?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://vicewrld.com/wp-content/uploads/2022/09/cropped-android-chrome-512x512-1.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot inprogress"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Live</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">Community Private Sale Round</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">VICEDAO
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">
                                        44,048,849.52294</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">48</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x2b0e1e521cB3deaF3e644A06C1D89aB4d8Ca3d08?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="/static/media/pinkswap.a95de4f3.png" alt="" loading="lazy" style={{ filter: "grayscale(1)" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">A2 Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">A2</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xbe57b776fBdd2e3AdDe4c47fb1E517821D30d218?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://vicewrld.com/wp-content/uploads/2022/09/cropped-android-chrome-512x512-1.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot inprogress"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Live</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">VICEWRLD Existing Holders</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">VICEDAO
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">
                                        219,997,723.96689233</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">1774
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x8b180E7E3da80263bBdbd3682E8D299C6D08BC84?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://vicewrld.com/wp-content/uploads/2022/09/cropped-android-chrome-512x512-1.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot inprogress"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Live</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">Pre-Seed Round</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">VICEDAO
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">
                                        30,490,342</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">21</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xf13100CC46179Ee6CbC102d5C5cd7e278144F40F?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://photos.pinksale.finance/file/pinksale-logo-upload/1664254591476-aa8ce68cf8d5f5bc519b5150df1ca9c8.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">GoCryptoMe V2 Platform Launch Celebration Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">GCME
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x4FC197703f884826Adf8b35261EF8F754CEc69E2?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://pinksale.infura-ipfs.io/ipfs/QmQH7bzLj8HJ5cBtzfqZun6i9VKJ3p5UmDCh7iGFiZotDE" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">Join the mascot of the world cup LaEeb </p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">LaEeb
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xd132d765a373a30cC9E481022484f07566a05C55?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://pinksale.infura-ipfs.io/ipfs/QmS2LxsMNssbr31wDamMpobMkCXb8D3uokEU6oajEwSWz3" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot canceled"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Cancelled</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">
                                0x7eF79B5da4e8B62ED0F2C49F570F2707769A2Bfa</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">BMB
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                  <div>Canceled</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xbdeb1BD910d17e676Fd339eba8b95870E6D6F84D?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://stretchtoearn.com/assets/images/logo-stn.png" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot incoming"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Upcoming</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">📣$11,000.00 is waiting for the lucky participants in the STN Airdrop Event😱
                              </p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">STN
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">0</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div>Starts In:</div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xFB52328226Fd24b26f6B9a302918c110E8e66F7B?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://ipfs.infura.io:/ipfs/QmeyeS1ubG2BQ7FRzSUfZWKQqaMA1v4oxrEhrjPgY5uttH" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot inprogress"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Live</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">TFBST AIRDROP</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">TFBST
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">21,687
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">2</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0x4431579939CEddA709901956803C2396847691B4?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="AirdropItem_root__1zAIn">
                        <div className="custom-card card is-flex is-flex-direction-column" style={{ height: "100%" }}>
                          <div className="card-content is-flex-grow-1">
                            <div className="media is-flex is-align-items-center">
                              <figure className="media-left" style={{ border: "1px solid rgba(249, 81, 146, 0.2)", borderRadius: "50%", overflow: " hidden" }}>
                                <p className="image is-48x48"><img src="https://ipfs.infura.io:/ipfs/QmTrev2sUPk4P7qV5quuCmC77JoN5YnxVDAwHgcoTv2hou" alt="" loading="lazy" style={{ filter: "grayscale(0);" }} /></p>
                              </figure>
                              <div className="media-content">
                                <div className="is-flex is-justify-content-flex-end">
                                  <div className="is-flex has-text-right is-flex-direction-column">
                                    <div className="is-flex"><span className="is-flex status-dot ended"><svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      stroke-width="0"
                                      viewBox="0 0 16 16"
                                      height="1em" width="1em"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="8" cy="8" r="8">
                                      </circle>
                                    </svg><span>Ended</span></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="content-title">
                              <p className="title">GEMSlots BST Airdrop</p>
                            </div>
                            <div className="TableInfo_root__1aCB2">
                              <table className="TableInfo_table__31voJ">
                                <tbody>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Token
                                    </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">BST
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">Total Token </td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">
                                        1,200,000</div>
                                    </td>
                                  </tr>
                                  <tr className="RowInfo_root__1XLti">
                                    <td className="RowInfo_node__3kZFW">
                                      Participants</td>
                                    <td className="RowInfo_node__3kZFW">
                                      <div className="has-text-right">2</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="custom-card-footer" style={{ borderTopWidth: "0px" }}>
                              <div className="is-flex is-align-items-center">
                                <div className="countdown is-flex-grow-1 is-flex-direction-column">
                                  <div></div>
                                </div>
                                <div className="view-pool has-text-right"><a className="view-button" href="/airdrop/0xAA15C6ADeB4039586A893Eadb8B62A40774D06EC?chain=BSC">View
                                  Airdrop</a></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-my" aria-labelledby="rc-tabs-0-tab-my"></div>
              <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-own" aria-labelledby="rc-tabs-0-tab-own"></div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
